<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="统计月份">
                <a-month-picker v-model="queryParam.month" placeholder="请选择月份" format="YYYY-MM" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="导购员手机号">
                <a-input v-model="queryParam.guideMobile" placeholder="请输入导购员手机号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="商家ID">
                <a-input v-model="queryParam.merchantId" placeholder="请输入商家ID" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="结算状态">
                <a-select v-model="queryParam.settleStatus" placeholder="请选择结算状态" allow-clear style="width: 100%">
                  <a-select-option :value="0">未结算</a-select-option>
                  <a-select-option :value="1">已结算</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
<!--      <div class="table-operations">-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['statistics:guide:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
<!--      </div>-->

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :bordered="tableBordered"
        @change="handleTableChange"
      >
        <span slot="guideAvatar" slot-scope="text">
          <a-avatar :src="text" icon="user" />
        </span>
        <span slot="orderCount" slot-scope="text">
          <a-tag color="blue">{{ text }}</a-tag>
        </span>
        <span slot="totalAmount" slot-scope="text">
          <a-tag color="green">¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}</a-tag>
        </span>
        <span slot="totalRefundAmount" slot-scope="text">
          <a-tag color="red">¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}</a-tag>
        </span>
        <span slot="totalCommission" slot-scope="text">
          <a-tag color="orange">¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}</a-tag>
        </span>
        <span slot="settleStatus" slot-scope="text">
          <a-tag :style="{ backgroundColor: text === 1 ? '#52c41a' : '#faad14', color: '#fff' }">{{ text === 1 ? '已结算' : '未结算' }}</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical" />
          <a v-if="record.settleStatus === 0" @click="handleSettle(record)">结算</a>
          <span v-else style="color: #ccc">已结算</span>
        </span>
      </a-table>
    </a-card>

    <!-- 详情弹窗 -->
    <a-modal
      title="导购要货统计详情"
      :visible="detailVisible"
      :footer="null"
      @cancel="handleCloseDetail"
      width="800px"
    >
      <a-descriptions bordered :column="2" v-if="detailInfo">
        <a-descriptions-item label="导购员ID">{{ detailInfo.guideId }}</a-descriptions-item>
        <a-descriptions-item label="导购员头像">
          <a-avatar :src="detailInfo.guideAvatar" icon="user" />
        </a-descriptions-item>
        <a-descriptions-item label="导购员姓名">{{ detailInfo.guideName }}</a-descriptions-item>
        <a-descriptions-item label="导购员手机号">{{ detailInfo.guideMobile }}</a-descriptions-item>
        <a-descriptions-item label="所属门店ID">{{ detailInfo.storeId }}</a-descriptions-item>
        <a-descriptions-item label="所属门店名称">{{ detailInfo.storeName }}</a-descriptions-item>
        <a-descriptions-item label="所属商家ID">{{ detailInfo.merchantId }}</a-descriptions-item>
        <a-descriptions-item label="所属商家名称">{{ detailInfo.merchantName }}</a-descriptions-item>
        <a-descriptions-item label="统计月份">{{ detailInfo.month }}</a-descriptions-item>
        <a-descriptions-item label="订单数量">{{ detailInfo.orderCount }}</a-descriptions-item>
        <a-descriptions-item label="订单总金额">¥{{ detailInfo.totalAmount ? parseFloat(detailInfo.totalAmount).toFixed(2) : '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="佣金总金额">¥{{ detailInfo.totalCommission ? parseFloat(detailInfo.totalCommission).toFixed(2) : '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="退款总金额">¥{{ detailInfo.totalRefundAmount ? parseFloat(detailInfo.totalRefundAmount).toFixed(2) : '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="结算状态">
          <a-tag :style="{ backgroundColor: detailInfo.settleStatus === 1 ? '#52c41a' : '#faad14', color: '#fff' }">{{ detailInfo.settleStatusName }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="结算时间">{{ detailInfo.settleTime || '-' }}</a-descriptions-item>
        <a-descriptions-item label="结算人">{{ detailInfo.settleUserName || '-' }}</a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { getGuidePurchaseStatisticsList, getGuidePurchaseStatisticsDetail, settleGuidePurchaseStatistics } from '@/api/statistics/guide'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'GuideOrderStatistics',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      detailVisible: false,
      detailInfo: null,
      queryParam: {
        month: undefined,
        guideMobile: undefined,
        merchantId: undefined,
        settleStatus: undefined,
        pageNo: 1,
        pageSize: 10
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        {
          title: '导购员ID',
          dataIndex: 'guideId',
          width: 100,
          align: 'center'
        },
        {
          title: '导购员头像',
          dataIndex: 'guideAvatar',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'guideAvatar' }
        },
        {
          title: '导购员姓名',
          dataIndex: 'guideName',
          width: 120,
          align: 'center'
        },
        {
          title: '导购员手机号',
          dataIndex: 'guideMobile',
          width: 130,
          align: 'center'
        },
        {
          title: '所属门店名称',
          dataIndex: 'storeName',
          width: 150,
          align: 'center'
        },
        {
          title: '所属商家名称',
          dataIndex: 'merchantName',
          width: 150,
          align: 'center'
        },
        {
          title: '统计月份',
          dataIndex: 'month',
          width: 100,
          align: 'center'
        },
        {
          title: '订单数量',
          dataIndex: 'orderCount',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'orderCount' }
        },
        {
          title: '订单总金额(元)',
          dataIndex: 'totalAmount',
          width: 140,
          align: 'center',
          scopedSlots: { customRender: 'totalAmount' }
        },
        {
          title: '退款总金额(元)',
          dataIndex: 'totalRefundAmount',
          width: 140,
          align: 'center',
          scopedSlots: { customRender: 'totalRefundAmount' }
        },
        {
          title: '佣金总金额(元)',
          dataIndex: 'totalCommission',
          width: 140,
          align: 'center',
          scopedSlots: { customRender: 'totalCommission' }
        },
        {
          title: '结算状态',
          dataIndex: 'settleStatus',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'settleStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    // 默认查询当前月份
    this.queryParam.month = moment()
    this.getList()
  },
  methods: {
    moment,
    getList() {
      this.loading = true
      const params = {
        pageNo: this.queryParam.pageNo,
        pageSize: this.queryParam.pageSize
      }

      if (this.queryParam.month) {
        params.month = moment(this.queryParam.month).format('YYYY-MM')
      }

      if (this.queryParam.guideMobile) {
        params.guideMobile = this.queryParam.guideMobile
      }

      if (this.queryParam.merchantId) {
        params.merchantId = this.queryParam.merchantId
      }

      if (this.queryParam.settleStatus !== undefined && this.queryParam.settleStatus !== '') {
        params.settleStatus = this.queryParam.settleStatus
      }

      getGuidePurchaseStatisticsList(params).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination, filters, sorter) {
      this.queryParam.pageNo = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleQuery() {
      this.queryParam.pageNo = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        month: moment(),
        guideMobile: undefined,
        merchantId: undefined,
        settleStatus: undefined,
        pageNo: 1,
        pageSize: 10
      }
      this.getList()
    },
    handleDetail(record) {
      this.loading = true
      getGuidePurchaseStatisticsDetail({ id: record.id }).then(response => {
        this.detailInfo = response.data
        this.detailVisible = true
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleCloseDetail() {
      this.detailVisible = false
      this.detailInfo = null
    },
    handleSettle(record) {
      this.$confirm({
        title: '确认结算',
        content: `确定要结算 ${record.guideName} ${record.month} 的要货统计吗？`,
        onOk: () => {
          this.loading = true
          settleGuidePurchaseStatistics({ id: record.id }).then(() => {
            this.$message.success('结算成功')
            this.getList()
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
}
</style>
